import {Outlet} from "react-router-dom";

export default function LoggedOutLayout() {
	return (
		<div className={"auth-container"}>
			<Outlet/>
		</div>
	)
}
